import { render, staticRenderFns } from "./HeaderDesktop.vue?vue&type=template&id=bfe5b076&"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports